<template>
  <div class="mx-auto max-w-6xl space-y-10 pb-12">
    <header class="text-center">
      <h1 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        {{ t('locations.page.title') }}
      </h1>
      <p class="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-gray-600">
        {{ t('locations.page.subtitle') }}
      </p>
    </header>

    <section class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <NuxtLink
        v-for="loc in locations"
        :key="loc.slug"
        :to="localePath(`/locations/${loc.slug}`)"
        class="group flex flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
      >
        <div class="relative aspect-[16/9] w-full overflow-hidden bg-gray-100">
          <img
            :src="loc.images[0]"
            :alt="t(`locations.${loc.slug}.name`)"
            class="block h-full w-full object-cover transition duration-300 group-hover:scale-105"
            loading="lazy"
          />
        </div>
        <div class="flex flex-1 flex-col p-5">
          <h2 class="text-xl font-semibold text-gray-900">
            {{ t(`locations.${loc.slug}.name`) }}
          </h2>
          <p class="mt-1 text-sm font-medium text-primary-700">
            {{ t(`locations.${loc.slug}.tagline`) }}
          </p>
          <p class="mt-3 line-clamp-3 text-sm leading-relaxed text-gray-600">
            {{ t(`locations.${loc.slug}.overview`) }}
          </p>
          <div class="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
            {{ t('locations.page.view_details') }}
            <UIcon
              name="i-heroicons-arrow-right"
              class="h-4 w-4 transition-transform group-hover:translate-x-0.5"
            />
          </div>
        </div>
      </NuxtLink>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { locations } from '~/data/locations'

const { t } = useI18n()
const localePath = useLocalePath()

useHead({
  title: () => `${t('locations.page.title')} — bLink`,
  meta: [{ name: 'description', content: () => t('locations.page.subtitle') }]
})
</script>
